import { Component, Input } from "@angular/core";

/**
 * Displays an inline error message with a times-circle icon.
 * Use `*ngIf` on the host to control visibility, and CSS classes
 * for spacing.
 *
 * @example
 * ```html
 * <rs-error-message *ngIf="errorFound" class="mb-3" [message]="errorMessage" />
 * ```
 */
@Component({
  selector: "rs-error-message",
  template: `
    <i class="pi pi-times-circle" aria-hidden="true"></i>
    <span>{{ message }}</span>
  `,
  host: {
    role: "alert"
  },
  styles: `
    :host {
      align-items: center;
      color: var(--rs-red);
      display: flex;
      gap: 0.5rem;
    }
  `,
  standalone: true
})
export class ErrorMessageComponent {
  @Input({ required: true }) message = "";
}
